module.exports = __webpack_public_path__ + "img/menu_bg.83c84ac4.png";